module.exports = __webpack_public_path__ + "static/img/slide-verify-03.e3289a11.jpg";